<template>
  <div id="itemcontainer" class="text-center">
    <h2 class="text-center">{{Title}}</h2>

      <div class="row" style="margin-top: 10px">
        <div class="col-md-12 text-center">
           <img :src="Image"/>
        </div>
     </div> 

    <kits-file-button
      ref="contractFile"
      v-on:change="contractFileChange"
      :withDownload="true"
      :removeFile="true"
    />
  </div>
</template>

<script>
import { truncate } from "fs";
import fileButton from "fwkits-core-presentation-vue/components/Buttons/KITSFileButton";

export default {
  components: { "kits-file-button": fileButton },
  props: {
    Title: {
      type: String,
      default: "",
      description: "",
    },
    Image: {
      type: String,
      default: "",
      description: "",
    },
    MissingItemEntityID: {
      type: Number,
      default: 0,
      description: "",
    },
  },
  data() {
    return {
      contractFile: {},
      file: { name: "", base64: "" },
      Errors: [],
    };
  },
  methods: {
    emitErrors(_context) {
      this.$emit("setErrors", _context.Errors);
    },
    change(element) {},
    contractFileChange(file) {
      var _context = this;
      if (file.name == "" && file.base64 == "") {
        _context.contractFile = null;
      } else {
        _context.contractFile = file;
      }

      /// Se guarda extensión, tipo y base64. Los 3 datos separados por ','
      _context.file = file.base64;

      if (_context.contractFile != null && _context.contractFile != undefined) {
        var arrayName = file.name.split(".");
        var extension = arrayName[arrayName.length - 1];

        this.JSONValue = JSON.stringify({
          Base64: file.base64.substring(file.base64.indexOf('base64,')+7),
          Extension: extension,
        });

        this.$emit("saveValue", {
          MissingItemEntityID: this.MissingItemEntityID,
          JSON: this.JSONValue,
        });

        _context.Errors = [];
        _context.emitErrors(_context);
      } else {
        _context.Errors = ["Debe seleccionar un archivo"];
        _context.emitErrors(_context);
      }
    },
  },
};
</script>